import { Button } from '@cian/ui-kit/button';
import { ModalWindow } from '@cian/ui-kit/modal';
import { ArticleHeading2 } from '@cian/ui-kit/typography';
import * as React from 'react';

import { HeatIndexFooterSection, HeatIndexSection } from '../../components/HeatIndex';
import { HeatIndexModalContentContainer } from './containers';
import { useHeatIndex } from './hooks';
import { trackOpenInformer } from './tracking';

export function HeatIndexContainer() {
  const [open, setOpen] = React.useState(false);
  const heatIndex = useHeatIndex();

  const handleOpen = React.useCallback(() => {
    trackOpenInformer();
    setOpen(true);
  }, []);

  const handleClose = React.useCallback(() => setOpen(false), []);

  if (!heatIndex) {
    return null;
  }

  return (
    <>
      <HeatIndexSection {...heatIndex} onClick={handleOpen} />
      <ModalWindow
        open={open}
        onClose={handleClose}
        fixed={false}
        size="M"
        width={628}
        header={<ArticleHeading2>Как считается индекс тепла</ArticleHeading2>}
        content={<HeatIndexModalContentContainer />}
        footer={
          <HeatIndexFooterSection>
            <Button size="XS" data-testid="close-btn" theme="fill_primary" onClick={handleClose}>
              Буду знать!
            </Button>
          </HeatIndexFooterSection>
        }
      />
    </>
  );
}
